import Component from './InputColor/Component'

function install(Vue) {
    Vue.component('InputColor', Component)
}

export default { install }
